import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = BASE ? `${BASE}/api` : null;

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
}

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("aor_admin_token") || ""}` });

export const submitDiagnostic = (payload) => axios.post(`${API}/diagnostic`, payload).then((r) => r.data);
